<template>
  <div id="ddLogin"> loging ····· </div>
</template>

<script>

  import { timeFix, getUrlQueryString } from '@/utils/util';

export default {
  name: "larkLogin",
  created() {
    const redirectUrl = window.location.href;
    if (redirectUrl.indexOf('code') < 0) {
      const larkAuthUrl = 'https://open.feishu.cn/open-apis/authen/v1/index?app_id=cli_a261680eed1e100d&redirect_uri=' + redirectUrl;
      window.location.href = larkAuthUrl;
    }
    this.authLogin();
  },
  methods: {
    authLogin() {
      const code = this.$route.query.code;
      const target = this.$route.params.target;
      const jsonCode = { "code": code }
      this.$store
        .dispatch("larkLogin", jsonCode)
        .then(() => {
          this.$router.push({ path: this.buildTargetUrl(target) })
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`,
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    buildTargetUrl(target) {
      return '/' + target.replace('-', '/');
    }
  },
}

</script>